import { Box } from '@mui/material';

type ImageColumnProps = {
  url: string;
};

export const ImageColumn = (props: ImageColumnProps) => {
  return props.url ? (
    <Box
      component='img'
      src={props.url}
      height={80}
      width={80}
      sx={{
        objectFit: 'contain',
      }}
    />
  ) : (
    <></>
  );
};
